import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import AppRoutes from './Routes'
import ReactGA from 'react-ga4'
import {initSentry} from './lib/sentry'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as ScThemeProvider } from 'styled-components'
import { muiTheme } from './theme/muiTheme'
import { theme } from './theme/styled-components-theme'

// Monitoramento de erros — inicializar antes de renderizar
initSentry()

// Analytics
const ga4_id = import.meta.env.VITE_GA4_ID || ''
if (ga4_id) {
    ReactGA.initialize(ga4_id)
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    // <React.StrictMode> // opcional
    <Sentry.ErrorBoundary
        fallback={<p>Algo deu errado. Por favor, recarregue a pagina.</p>}
        showDialog={false}
    >
        <MuiThemeProvider theme={muiTheme}>
            <ScThemeProvider theme={theme}>
                <AppRoutes />
            </ScThemeProvider>
        </MuiThemeProvider>
    </Sentry.ErrorBoundary>
    // </React.StrictMode>
)
